export const checkCondition = (cond: any, trueval: any, falseval?: any) => cond ? trueval: falseval

export const checkConditionFun = (cond: any, trueval: any, falseval?: any) => cond ? trueval(): falseval()